import {Template} from 'TemplateEditor/template'
import {EventImage} from 'event/models/EventImages'
import {Organization} from 'organization/models/Organization'
import {Image} from 'organization/ImageSelector'
import {SaveEventData} from 'organization/Event/Settings/SaveEvent'
import {Certificate} from 'organization/Event/Certification/Certificate'

/** A purchasable ticket tier for an event (from `event_tickets`). */
export type EventTicketOption = {
  id: number
  name: string
  price: number
  sort_order: number
  /** JSON array string, same shape as legacy `event.ticket_features`. */
  ticket_features: string
}

export interface EventModel {
  id: number
  name: string
  slug: string
  is_free: boolean
  short_description: string
  description: string
  video: string
  organization: Organization
  price: number
  ticket_name: string
  ticket_features: string
  total_seats: number
  available_seats: number
  occupied_seats: number
  date: Date
  time: string
  duration: number
  page_date: Date
  template: Template
  images: EventImage[]
  is_public: boolean
  is_ended: boolean
  published_at: Date
  ended_at: Date
  paid?: boolean
  has_ticket?: boolean
  certificate?: Certificate | null
  connection_token: string
  is_live: boolean
  /** UI / checkout language for default ticket copy: bg, en, tr, de, sv */
  locale?: string
  /** Ticket tiers when the API exposes `event_tickets` (ordered). */
  tickets?: EventTicketOption[]
  /** Set on attendee preview: purchased `event_tickets.id` for template tier visibility. */
  viewer_event_ticket_id?: number | null
}

export function getEventImageUrl(event: EventModel | null, imageType: number) {
  const find = event?.images.find((image) => image.type_id === imageType)

  if (find) {
    return find.image.url
  }

  return null
}

export function getEventImage(event: EventModel | null, imageType: number) {
  const find = event?.images.find((image) => image.type_id === imageType)

  if (find) return find

  return null
}

export function updateEventImagesAgregate(
  images: SaveEventData['images'],
  imageType: number,
  updatedImage: Image | null,
) {
  if (!images) {
    return [
      {
        type_id: imageType,
        image_id: updatedImage?.id ?? null,
      },
    ]
  }

  const exists = images.find((image) => image.type_id === imageType)

  if (exists) {
    return images.map((updateImage) => {
      if (updateImage.type_id === imageType) {
        return {
          ...updateImage,
          image_id: updatedImage?.id ?? null,
        }
      }

      return updateImage
    })
  } else {
    images.push({
      type_id: imageType,
      image_id: updatedImage?.id ?? null,
    })
    return images
  }
}
